export const SUPPORT_EMAIL = 'support@greatquestion.co';
export const PLATFORM_SENDER_EMAIL = 'support@greatquestion.co';
